import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-item-info-dialog',
  standalone: false,
  templateUrl: './item-info-dialog.component.html',
  styleUrl: './item-info-dialog.component.scss',
})
export class ItemInfoDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<ItemInfoDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {

	}
}
